import { SlidersHorizontal } from 'lucide-react'

import { Button } from '@/components/base/button'
import { useI18n } from '@/i18n/i18n-react'
import { clx } from '@/utils/clx'

/**
 * Shared "Filters" trigger used across list pages. Renders the sliders icon and, when there are any
 * active filters, a compact count next to it. Opens the page's advanced-filter drawer on click.
 */
export function FilterButton({
	onClick,
	activeCount = 0,
	className
}: {
	onClick: () => void
	/** Number of active filters; shown as a badge and omitted when zero. */
	activeCount?: number
	className?: string
}) {
	const { L } = useI18n()
	const hasCount = activeCount > 0

	return (
		<Button
			variant='secondary'
			size='small'
			onClick={onClick}
			// Match the h-8 height of the search input / interval buttons, and stay square (icon-only)
			// until an active-filter count needs to be shown alongside the icon.
			className={clx('h-8', hasCount ? 'gap-x-1 px-2' : 'w-8 justify-center p-0', className)}
			aria-label={L.General.AdvancedFilters()}
		>
			<SlidersHorizontal className='size-4' />
			{hasCount && <span className='tabular-nums'>{activeCount}</span>}
		</Button>
	)
}
